
import { TextField,Autocomplete } from "@mui/material";
import { styled } from "@mui/material/styles";


export const CustomInputField= styled(TextField)(({ theme, ...props }) => ({
    "& input": {
        background: props.background ? props.background : "#EFF0F2",
        borderRadius: "5px",
        padding: "10px 15px",
        borderLeft: props.required ? "2px solid #EF3434" : "0",
        marginBottom: "10px",
        color: "rgb(0 0 0 / 60%)",
        fontSize: "13px",
    },
    "& .MuiFormLabel-asterisk": {
        display: "none",
    },
    "& fieldset": {
        border: "0",
    },
    "& label": {
        lineHeight: "initial",
        fontSize: "13px",
    },
    "& .MuiInputLabel-shrink": {
        transform: " translate(14px, -7px) scale(0.8) !important",
    },
    "& .MuiInputLabel-root": {
        transform: "translate(14px, 9px) scale(1)",
    },
}));


export const CustomTextArea = styled(TextField)(({ theme, ...props }) => ({
    "& textarea": {
      minHeight: "70px",
      maxHeight: "70px",
      overflow: "auto !important",
      fontSize: "13px",
    },
    "& .MuiInputBase-root": {
      background: props.background ? props.background : "#EFF0F2",
      borderRadius: "5px",
      borderLeft: props.required ? "2px solid #EF3434" : "0",
    },
    "& fieldset": {
      borderColor: "transparent",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#EFF0F2 !important",
    },
    "& label": {
      lineHeight: "initial",
      fontSize: "13px",
    },
    "& .MuiInputLabel-shrink": {
      transform: " translate(11px, -7px) scale(0.8) !important",
    },
    "& .MuiInputLabel-root": {
      transform: "translate(11px, 7px) scale(1)",
    },
  }));


  export const CustomAutoComplete = styled(Autocomplete)(
    ({ theme, ...props }) => ({
      width: "100%",
      "& input": {
        background: props.background ? props.background : "#EFF0F2",
        borderRadius: "5px",
        padding: "10px 15px !important",
        borderLeft: props.required ? "2px solid #EF3434" : "0",
        fontSize: "13px",
      },
      "& .MuiOutlinedInput-root": {
        background: props.background ? props.background : "#EFF0F2",
        borderRadius: "5px",
        marginBottom: "10px",
      },
      "& .MuiTextField-root": {
        margin: 0,
      },
      "& fieldset": {
        border: "0",
      },
      "& label": {
        lineHeight: "initial",
        fontSize: "13px",
      },
      "& .MuiInputLabel-shrink": {
        // background: "#ffffff",
        transform: " translate(14px, -7px) scale(0.8) !important",
      },
      "& .MuiInputLabel-root": {
        transform: "translate(14px, 9px) scale(1)",
      },
      " & .MuiOutlinedInput-root": {
        padding: "0",
      },
    })
  );